import React, { memo, forwardRef } from "react";
const SvgHermitianconjugate = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        stroke="#717171"
        strokeWidth={0.3}
        d="M19.853 11.302h0l.002-.004a.912.912 0 00.08-.409V8.716h2.753v2.173c0 .155.023.294.08.409h0l.003.004c.05.092.108.171.18.234h0l.005.005a.584.584 0 00.254.122c.074.02.144.031.21.031a.817.817 0 00.208-.031.524.524 0 00.247-.124.77.77 0 00.192-.237h0l.003-.004a.912.912 0 00.08-.409V5.504a.89.89 0 00-.08-.399l-.134.067.134-.067a.746.746 0 00-.195-.25.525.525 0 00-.247-.124.82.82 0 00-.209-.032.82.82 0 00-.209.032.584.584 0 00-.254.121h0l-.005.005a.813.813 0 00-.183.248l.135.067-.134-.067a.89.89 0 00-.08.4V7.42h-2.753V5.504a.89.89 0 00-.08-.399.746.746 0 00-.195-.25.525.525 0 00-.247-.124.82.82 0 00-.209-.032.82.82 0 00-.209.032.584.584 0 00-.254.121h0l-.006.005a.813.813 0 00-.182.248.89.89 0 00-.08.4v5.384c0 .155.023.294.08.409h0l.003.004c.049.092.108.171.18.234h0l.005.005a.584.584 0 00.254.122c.074.02.144.031.209.031a.817.817 0 00.209-.031.524.524 0 00.247-.124.77.77 0 00.192-.237z"
      />
      <rect width={10} height={14} x={8} y={11.472} fill="#DBDBDB" rx={2} />
    </svg>
  );
});
SvgHermitianconjugate.displayName = "SvgHermitianconjugate";
const MemoForwardRef = memo(SvgHermitianconjugate);
export default MemoForwardRef;
